import * as Yup from 'yup';

export const AppNotificationIntialValues = {
  phase: null,
  title: '',
  message: '',
  day: '',
};

export const AppNotificationValidationSchema = Yup.object()
  .shape({
    phase: Yup.string().required('Please select phase'),
    title: Yup.string().required('Please enter title'),
    message: Yup.string().required('Please enter message'),
    day: Yup.number()
      .typeError('Day must be a number')
      .required('Please select a day')
      .min(1, 'Days must between 1 to 22')
      .max(35, 'Days must between 1 to 22')
  })
  .defined();

export const InsightSearchBarInitialValues = {
  search: '',
  country_id: null,
  type_id: null,
  year: { label: 2023, value: 2023 },
};

export const AppNotificationSearchBarInitialValues = {
  search: '',
};
